var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"inner"},[_vm._m(0),_vm._v(" "),_c('main',{attrs:{"id":"board"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require(`~/assets/img/ir/IR2.jpg`),"alt":"인포스탁 기업 IR"}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"pageHeader"},[_c('div',{staticClass:"txt"},[_vm._v("인포스탁 기업 IR")])])
}]

export { render, staticRenderFns }